// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DxnWt{align-items:center;text-align:center;min-width:100%;max-width:600px}.DxnWt .T9jF2{margin-top:40px}.DxnWt .Nztif{margin-top:16px}.ypbRt{align-items:center;gap:8px}.tbmt1{align-items:flex-start;gap:16px}.IXxUG{justify-content:space-between;align-items:flex-start}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"thankYouSectionWrapper": `DxnWt`,
	"desktop": `T9jF2`,
	"mobile": `Nztif`,
	"thankYouSection": `ypbRt`,
	"recipientsSection": `tbmt1`,
	"recipientsSectionRow": `IXxUG`
};
export default ___CSS_LOADER_EXPORT___;
